import { render, staticRenderFns } from "./RadioDropdown.vue?vue&type=template&id=af46d966&scoped=true"
import script from "./RadioDropdown.vue?vue&type=script&lang=js"
export * from "./RadioDropdown.vue?vue&type=script&lang=js"
import style0 from "./RadioDropdown.vue?vue&type=style&index=0&id=af46d966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af46d966",
  null
  
)

export default component.exports